import { z } from 'zod';

export const FullPromotionCopilotDefinition = z
  .object({
    copilotType: z.literal('promotion'),
  })
  .describe('FullPromotionCopilotDefinition');

export type FullPromotionCopilotDefinition = z.infer<
  typeof FullPromotionCopilotDefinition
>;

// We exclude any fields here that are data set references, since they cause a cache miss on the dependency due to the schema changing.
// In the case of the PromotionCopilotDefinition, there are no additional fields to exclude, so it ends up being an alias for FullPromotionCopilotDefinition.
export const PromotionCopilotDefinition = FullPromotionCopilotDefinition;

export type PromotionCopilotDefinition = z.infer<
  typeof PromotionCopilotDefinition
>;
